<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="page_7"></a><img alt="image" class="svg" src="html/images/image14.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607056188_07_pt01.vue?2ab6336a